import Vue from "vue";
import Login from "@/views/Login.vue";
import store from "@/store";
import { WEB_PERMISSIONS as P } from "@/constants/webPermissions";
import { hasPermission } from "@/Utils/permission";

import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: { public: true },
  },
  {
    path: "/403",
    name: "Forbidden",
    component: () => import("../views/Forbidden.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/NavBar",
    name: "NavBar",
    component: () => import("../views/NavBar.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "Panel", // 修改为相对路径
        name: "Panel",
        component: () => import("../views/Panel/Panel.vue"),
        meta: { permission: P.DASHBOARD_HOME_VIEW, menu: false },
      },
      {
        path: "OestrusAlgorithm",
        name: "OestrusAlgorithm",
        component: () =>
          import("../views/Algorithm/estrus/EstrusAlgorithm.vue"),
        meta: { permission: P.ALGORITHM_ESTRUS_VIEW },
      },
      {
        path: "DiseaseAlgorithm",
        name: "DiseaseAlgorithm",
        component: () =>
          import("../views/Algorithm/disease/DiseaseAlgorithm.vue"),
        meta: { permission: P.ALGORITHM_DISEASE_VIEW },
      },
      {
        path: "CalvingAlgorithm",
        name: "CalvingAlgorithm",
        component: () =>
          import("../views/Algorithm/calving/CalvingAlgorithm.vue"),
        meta: { permission: P.ALGORITHM_CALVING_VIEW },
      },
      {
        path: "DashBoard",
        name: "DashBoard",
        component: () => import("../views/DashBoard.vue"),
        meta: { permission: P.DASHBOARD_HOME_VIEW },
      },
      {
        path: "ChangeAlgoAttr",
        name: "ChangeEstrusAttr",
        component: () =>
          import("../views/Algorithm/estrus/ChangeEstrusAttr.vue"),
        meta: { permission: P.ALGORITHM_ESTRUS_MANAGE },
      },
      {
        path: "ChangeDiseaseAlgoAttr",
        name: "ChangeDiseaseAttr",
        component: () =>
          import("../views/Algorithm/disease/ChangeDiseaseAttr.vue"),
        meta: { permission: P.ALGORITHM_DISEASE_MANAGE },
      },
      {
        path: "ChangeCalvingAlgoAttr",
        name: "ChangeCalvingAttr",
        component: () =>
          import("../views/Algorithm/calving/ChangeCalvingAttr.vue"),
        meta: { permission: P.ALGORITHM_CALVING_MANAGE },
      },
      {
        path: "Data/CheckValueError",
        name: "CheckValueError",
        component: () => import("../views/Data/CheckValueError.vue"),
        meta: { permission: P.DATA_CHECK_VALUE_ERROR_VIEW },
      },
      {
        path: "Data/Table",
        name: "Table",
        component: () => import("../views/Data/DataTable/DataTable.vue"),
        meta: { permission: P.DATA_TABLE_VIEW },
      },
      {
        path: "Data/Chart",
        name: "Chart",
        component: () => import("../views/Data/DataChart.vue"),
        meta: { permission: P.DATA_CHART_VIEW },
      },
      {
        path: "Data/DataPieChart",
        name: "DataPieChart",
        component: () => import("../views/Data/DataPieChart.vue"),
        meta: { permission: P.DATA_PIE_CHART_VIEW },
      },
      {
        path: "Data/Avg",
        name: "Avg",
        component: () => import("../views/Data/AvgChart.vue"),
        meta: { permission: P.DATA_AVG_VIEW },
      },
      {
        path: "Data/Catone",
        name: "CatoneData",
        component: () => import("../views/Data/CatoneData.vue"),
        meta: { permission: P.DATA_CATONE_VIEW },
      },
      {
        path: "Archive/Detail",
        name: "ArchiveDetail",
        component: () => import("../views/Archive/ArchiveDetail.vue"),
        meta: { permission: P.ARCHIVE_DETAIL_VIEW },
      },
      {
        path: "Archive/History",
        name: "ArchiveHistory",
        component: () => import("../views/Archive/ArchiveHistory.vue"),
        meta: { permission: P.ARCHIVE_HISTORY_VIEW },
      },
      {
        path: "AlgorithmAttr",
        name: "AlgorithmAttr",
        component: () => import("@/views/Device/AlgorithmAttr.vue"),
        meta: { permission: P.DEVICE_ALGORITHM_PARAM_VIEW },
      },
      {
        path: "DeviceInfo",
        name: "DeviceInfo",
        component: () => import("@/views/Device/DeviceInfo.vue"),
        meta: { permission: P.DEVICE_INFO_VIEW },
      },
      {
        path: "TimeInterval",
        name: "TimeInterval",
        component: () => import("@/views/Device/TimeInterval.vue"),
        meta: { permission: P.DEVICE_TIME_INTERVAL_VIEW },
      },
      {
        path: "TimeCalibration",
        name: "CheckValue",
        component: () => import("@/views/Device/TimeCalibration.vue"),
        meta: { permission: P.DEVICE_TIME_CALIBRATION_VIEW },
      },
      {
        path: "LostBags",
        name: "LostBags",
        component: () => import("@/views/Device/LostBags.vue"),
        meta: { permission: P.DEVICE_PACKET_LOSS_VIEW },
      },
      {
        path: "ConvertToExcel",
        name: "ConvertToExcel",
        component: () => import("@/views/Device/ConvertToExcel.vue"),
        meta: { permission: P.TOOL_CONVERT_VIEW },
      },
      {
        path: "CheckDeviceInfo",
        name: "CheckDeviceInfo",
        component: () => import("@/views/Device/CheckDeviceInfo.vue"),
        meta: { permission: P.QUALITY_FACTORY_DEVICE_VIEW },
      },
      {
        path: "CheckDeviceInfoLog",
        name: "CheckDeviceInfoLog",
        component: () => import("@/views/Device/CheckDeviceInfoLog.vue"),
        meta: { permission: P.QUALITY_OPERATION_LOG_VIEW },
      },
      {
        path: "Batch",
        name: "Batch",
        component: () => import("@/views/Device/Batch.vue"),
        meta: { permission: P.TOOL_BATCH_VIEW },
      },
      {
        path: "DeviceID",
        name: "DeviceID",
        component: () => import("@/views/Device/DeviceID.vue"),
        meta: { permission: P.DEVICE_INFO_VIEW, menu: false },
      },
      {
        path: "IllBehave",
        name: "IllBehave",
        component: () => import("@/views/Device/IllegalBehavior.vue"),
        meta: { permission: P.DEVICE_ACTIVITY_VIEW },
      },
      {
        path: "DeviceScan",
        name: "DeviceScan",
        component: () => import("@/views/Device/DeviceScan/index.vue"),
        meta: { permission: P.DEVICE_SCAN_VIEW },
      },
      {
        path: "Monitor/Overview",
        name: "MonitorOverview",
        component: () => import("@/views/Monitor/SystemOverview.vue"),
        meta: { permission: P.MONITOR_OVERVIEW_VIEW },
      },
      {
        path: "Monitor/Observation",
        name: "MonitorObservation",
        component: () => import("@/views/Monitor/ObservationOverview.vue"),
        meta: { permission: P.MONITOR_OBSERVATION_VIEW },
      },
      {
        path: "Monitor/Devices",
        name: "MonitorDevices",
        component: () => import("@/views/Monitor/DeviceMonitor.vue"),
        meta: { permission: P.MONITOR_DEVICE_VIEW },
      },
      {
        path: "Monitor/PackLoss",
        name: "MonitorPackLoss",
        component: () => import("@/views/Monitor/PackLossMonitor.vue"),
        meta: { permission: P.MONITOR_PACKET_LOSS_VIEW },
      },
      {
        path: "Monitor/AlgorithmTasks",
        name: "MonitorAlgorithmTasks",
        component: () => import("@/views/Monitor/AlgorithmTaskMonitor.vue"),
        meta: { permission: P.MONITOR_ALGORITHM_TASK_VIEW },
      },
      {
        path: "Monitor/TableGrowth",
        name: "MonitorTableGrowth",
        redirect: "/NavBar/Monitor/TableGrowth/Data",
        meta: { permission: P.MONITOR_TABLE_GROWTH_DATA_VIEW },
      },
      {
        path: "Monitor/TableGrowth/Data",
        name: "MonitorTableGrowthData",
        component: () => import("@/views/Monitor/TableGrowth/TableGrowthData.vue"),
        meta: { permission: P.MONITOR_TABLE_GROWTH_DATA_VIEW },
      },
      {
        path: "Monitor/TableGrowth/Config",
        name: "MonitorTableGrowthConfig",
        component: () => import("@/views/Monitor/TableGrowth/TableGrowthConfig.vue"),
        meta: { permission: P.MONITOR_TABLE_GROWTH_CONFIG_VIEW },
      },
      {
        path: "Monitor/TableGrowth/Fields",
        name: "MonitorTableGrowthFields",
        redirect: "/NavBar/Monitor/TableGrowth/Data",
        meta: { permission: P.MONITOR_TABLE_GROWTH_DATA_VIEW },
      },
      {
        path: "Monitor/TableGrowth/History",
        name: "MonitorTableGrowthHistory",
        component: () => import("@/views/Monitor/TableGrowth/TableGrowthHistory.vue"),
        meta: { permission: P.MONITOR_TABLE_GROWTH_HISTORY_VIEW },
      },
      {
        path: "Settings/Mail",
        name: "SettingsMail",
        component: () => import("@/views/Settings/MailManage.vue"),
        meta: { permission: P.SETTINGS_MAIL_CONFIG_VIEW },
      },
      {
        path: "Settings/MailHistory",
        name: "SettingsMailHistory",
        component: () => import("@/views/Settings/MailHistory.vue"),
        meta: { permission: P.SETTINGS_MAIL_HISTORY_VIEW },
      },
      {
        path: "ClientPush/MqttClient",
        name: "MqttClientConfig",
        component: () => import("@/views/ClientPush/MqttClientConfig.vue"),
        meta: { permission: P.CLIENT_PUSH_MQTT_VIEW },
      },
      {
        path: "ClientPush/Config",
        name: "ClientPushConfig",
        component: () => import("@/views/ClientPush/ClientPushConfig.vue"),
        meta: { permission: P.CLIENT_PUSH_CONFIG_PAGE_VIEW },
      },
      {
        path: "ClientPush/History",
        name: "ClientPushHistory",
        component: () => import("@/views/ClientPush/ClientPushHistory.vue"),
        meta: { permission: P.CLIENT_PUSH_HISTORY_VIEW },
      },
      {
        path: "Access/Users",
        name: "AccessUsers",
        component: () => import("@/views/Access/UserManage.vue"),
        meta: { permission: P.ACCESS_USER_VIEW },
      },
      {
        path: "Access/Roles",
        name: "AccessRoles",
        component: () => import("@/views/Access/RoleManage.vue"),
        meta: { permission: P.ACCESS_ROLE_VIEW },
      },
      {
        path: "Access/Audit",
        name: "AccessAudit",
        component: () => import("@/views/Access/AuditLog.vue"),
        meta: { permission: P.ACCESS_AUDIT_VIEW },
      },
      {
        path: "MilkParlor/PosIden",
        name: "MilkParlorPresenceIdentification",
        component: () => import("@/views/MilkParlor/PosIden.vue"),
        meta: { permission: P.MILK_PARLOR_PRESENCE_IDENTIFICATION_VIEW },
      },
      {
        path: "MilkParlor/MilkUpl",
        name: "MilkParlorMilkUpload",
        component: () => import("@/views/MilkParlor/MilkUpl.vue"),
        meta: { permission: P.MILK_PARLOR_TOPOLOGY_VIEW },
      },
      {
        path: "MilkParlor/Stall",
        name: "MilkParlorStallBinding",
        component: () => import("@/views/MilkParlor/Stall.vue"),
        meta: { permission: P.MILK_PARLOR_TOPOLOGY_VIEW },
      },
      {
        path: "MilkParlor/Outbox",
        name: "MilkParlorOutbox",
        component: () => import("@/views/MilkParlor/OutboxLog.vue"),
        meta: { permission: P.MILK_PARLOR_OUTBOX_VIEW },
      },
      {
        path: "MilkParlor/RawCommand",
        name: "MilkParlorRawCommand",
        component: () => import("@/views/MilkParlor/RawCommand.vue"),
        meta: { permission: P.MILK_PARLOR_RAW_COMMAND_VIEW },
      },
    ],
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = store.state.token;
  const requiresAuth = to.matched.some(
    (record) => record.meta.requiresAuth || record.meta.permission
  );

  if (requiresAuth && !token) {
    store.dispatch("clearAuth");
    next("/");
    return;
  }

  if (token && !store.state.authInitialized) {
    try {
      await store.dispatch("initializeAuth");
    } catch (error) {
      if (error.status === 401) {
        next("/");
      } else if (requiresAuth) {
        next(false);
      } else {
        next();
      }
      return;
    }
  }

  if (to.path === "/" && token && store.state.authInitialized) {
    next("/NavBar");
    return;
  }

  const permissionRecord = [...to.matched]
    .reverse()
    .find((record) => record.meta.permission);
  if (
    permissionRecord &&
    !hasPermission(store.state.permissions, permissionRecord.meta.permission)
  ) {
    next("/403");
    return;
  }

  next();
});

export default router;
